import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { reel, poster } from "@/lib/media";

const KEYS = ["taller", "obra", "mostrador", "cocina", "fijacion"];

export const HeroReels = () => {
    const [i, setI] = useState(0);

    const next = () => setI((p) => (p + 1) % KEYS.length);

    useEffect(() => {
        const t = setTimeout(next, 8000); // fallback advance
        return () => clearTimeout(t);
    }, [i]);

    return (
        <div className="absolute inset-0 z-0 overflow-hidden bg-verde-900">
            <AnimatePresence mode="sync">
                <motion.video
                    key={i}
                    src={reel(KEYS[i])}
                    poster={poster(KEYS[i])}
                    autoPlay
                    muted
                    playsInline
                    onEnded={next}
                    initial={{ opacity: 0, scale: 1.06 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ opacity: { duration: 1 }, scale: { duration: 8, ease: "linear" } }}
                    className="absolute inset-0 w-full h-full object-cover"
                />
            </AnimatePresence>
            <div className="absolute inset-0 bg-gradient-to-t from-verde-900 via-verde-900/60 to-verde-900/35" />
            <div className="absolute bottom-6 right-5 md:right-8 z-10 flex gap-1.5">
                {KEYS.map((_, idx) => (
                    <button
                        key={idx}
                        onClick={() => setI(idx)}
                        data-testid={`hero-reel-dot-${idx}`}
                        aria-label={`Reel ${idx + 1}`}
                        className={`h-1.5 rounded-full transition-all ${idx === i ? "w-7 bg-madera" : "w-2.5 bg-white/40"}`}
                    />
                ))}
            </div>
        </div>
    );
};
